/**
 * Created by Lauta on 2/3/2017.
 */
export class MessageSeverity{
    public static INFORMATICON = 'info';
    public static SUCCESS = 'success';
    public static WARNING = 'warn';
    public static ERROR = 'error';
}



// WEBPACK FOOTER //
// ./src/app/core/commons/message-severity.ts